import BaseAPI from 'api/api'

/** UTIILS */
import { getBranch, getServicePoint, getToken } from 'utils/app.utils'

export interface PropsShortcutPermission {
  servicePointId: number
  branchId: number
}

export default class LoginApi extends BaseAPI {
  static login(username: string, password: string): Promise<{
    accessToken: string
    refreshToken: string
    tokenExpiresAt: string
    refreshTokenExpiresAt: string
  }> {
    return this.api.post('login', { username, password }, {}).then(({ data }: any) => ({
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
      tokenExpiresAt: data.tokenExpiresAt,
      refreshTokenExpiresAt: data.refreshTokenExpiresAt
    }))
  }

  static whoami(): Promise<boolean> {
    return this.api.post('whoami')
  }

  static forgetPassword(email: string): Promise<any> {
    const token = getToken()
    return this.api.post('forget-password', { email }, { headers: { authorization: `Bearer ${token}` } }).then((res) => res)
  }

  static roles(): Promise<any> {
    return this.api.get('role-user', {})
  }

  static findByToken(token: string): Promise<any> {
    return this.api.get(`validate-token`, { params: { token } })
  }

  static rememberMe(token: string): Promise<any> {
    return this.api.get(`remember-me`, { params: { token } })
  }

  static pick(branchId: string, servicePointId: string): Promise<any> {
    const token = getToken()
    return this.api
      .post('pick', { token, branchId, servicePointId })
      .then(() => true)
      .catch(() => false)
  }

  static rolesPermission(props: PropsShortcutPermission): Promise<any> {
    return this.api.get('role-permissions', { params: { ...props } }).then((res) => res)
  }

  static shortcutPermission(props: PropsShortcutPermission): Promise<any> {
    return this.api.get(`role-permissions-shortcut`, { params: { ...props } }).then((res) => res)
  }

  static menus(): Promise<any> {
    const branchId = getBranch()
    const servicePointId = getServicePoint()
    return this.api.get('menus', { params: { branchId, servicePointId } }).then((res) => res)
  }

  static logout(): Promise<any> {
    const token = getToken()
    if (!token) return Promise.resolve({ success: false })

    return this.api.post('logout', {}, { headers: { authorization: `Bearer ${token}` } })
      .then((res) => res.data)
      .catch(() => ({ success: false })) // Continue logout even if API call fails
  }

  static refreshToken(refreshToken: string): Promise<{
    accessToken: string
    tokenExpiresAt: string
  }> {
    return this.api.post('refresh-token', { refreshToken }, {})
      .then(({ data }: any) => ({
        accessToken: data.accessToken,
        tokenExpiresAt: data.tokenExpiresAt
      }))
      .catch((error) => {
        console.error('Failed to refresh token:', error)
        throw error
      })
  }
}
